/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-07-17 15:41:38
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-09-10 16:18:32
 * @FilePath: \web\sznc_industry\src\router\routes\modules\shopDecoration.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
export default [
    {
        path: 'decorationColumnManage',
        name: {list:['系统管理','装修','PC装修','栏目管理']},
        component: () => import('@/views/shopDecoration/views/columnManage.vue')
      },{
        path: 'szgxnavigationManage',
        name: {list:['数字供销','装修','PC装修','导航管理']},
        component: () => import('@/views/shopDecoration/views/navigationManage.vue')
      },
      // {
      //   path: 'chatIndex',
      //   name: {list:['数字供销','在线客服','在线客服','在线客服']},
      //   component: () => import('@/components/chat/chatIndex')
      // },
      {
        path: 'chatIndex',
        name: {list:['数字供销','在线客服','在线客服','在线客服']},
        component: () => import('@/views/agent/index')
      },{
        path: 'decorationbaseMoudle',
        name: {list:['系统管理','装修','PC装修','内容管理']},
        component: () => import('@/views/shopDecoration/views/baseMoudle.vue')
      },{
        path: 'decorationModuleAdd',
        name: {list:['系统管理','装修','PC装修','内容管理','添加模块内容'],title:'添加模块内容'},
        component: () => import('@/views/shopDecoration/views/moduleEdit.vue')
      },{
        path: 'decorationModuleEdit',
        name: {list:['系统管理','装修','PC装修','内容管理','编辑模块内容'],title:'编辑模块内容'},
        component: () => import('@/views/shopDecoration/views/moduleEdit.vue')
      },{
        path: 'decorationConfigurationShare',
        name: {list:['系统管理','装修','PC装修','门户推广']},
        component: () => import('@/views/shopDecoration/views/configurationShare.vue')
      },{
        path: 'homeDecoration',
        name: {list:['系统管理','装修','PC装修','首页装修']},
        component: () => import('@/views/shopDecoration/views/homeDecoration.vue')
      },{
        path: 'doorDecoration',
        name: {list:['产业门户','门户','PC装修','首页装修']},
        component: () => import('@/views/shopDecoration/views/homeDecoration.vue')
      },{
        path: 'homeSpecialDecoration',
        name: {list:['系统管理','装修','PC装修','专题装修']},
        component: () => import('@/views/shopDecoration/views/homeDecoration.vue')
      },{
        path: 'doorSpecialDecoration',
        name: {list:['产业门户','门户','PC装修','专题装修']},
        component: () => import('@/views/shopDecoration/views/homeDecoration.vue')
      }
      ,{
        path: 'bannerAd',
        name: {list:['产业门户','门户','PC装修','首页装修']},
        component: () => import('@/views/shopDecoration/components/base/bannerFloor/bannerAd.vue')
      }
      ,{
        path: 'doorDecorationH5',
        name: {list:['产业门户','门户','移动门户','移动首页装修']},
        component: () => import('@/views/shopDecoration/views/homeDecorationH5.vue')
      }
      ,{
        path: 'doorSpecialDecorationH5',
        name: {list:['产业门户','门户','移动门户','移动专题装修']},
        component: () => import('@/views/shopDecoration/views/homeDecorationH5.vue')
      }
      
]